import { useMemo } from 'react'
import { Scenario } from '../../shared/types'

export const useScenarioNames = (scenarios: Scenario[]) => {
  return useMemo(() => {
    const getScenarioName = (scenarioId: string): string => {
      const index = scenarios.findIndex((s) => s.id === scenarioId)
      return index >= 0 ? `Scenario ${index + 1}` : 'Unknown Scenario'
    }

    const scenarioNamesMap: { [scenarioId: string]: string } = {}
    scenarios.forEach((scenario, idx) => {
      scenarioNamesMap[scenario.id] = `Scenario ${idx + 1}`
    })

    return { getScenarioName, scenarioNamesMap }
  }, [scenarios])
}
